export default "__VITE_ASSET__fa52af00__"